import { Component } from 'react'

export default class ErrorBoundary extends Component {
  state = { error: null }
  
  static getDerivedStateFromError(error) {
    return { error }
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{padding: '20px', color: 'red'}}>
          <h2>Something went wrong</h2>
          <pre>{this.state.error.toString()}</pre>
        </div>
      )
    }
    return this.props.children
  }
}